import { useAppDispatch } from "app/store";

import { formatToggled } from "./slice";

/**
 * Hook for handling side navigation events
 */
export const useOnClickHandler = () => {
  const dispatch = useAppDispatch();

  return () => {
    dispatch(formatToggled());
  };
};
